/**
 * Rate limiting for the automation notification growls.
 *
 * Both of these arrive in bursts for a single user action — one change can run
 * several automations, and the cascade limit is reported once per queued
 * message over the limit — so raising one growl per event buries the screen.
 */

// Long enough to catch the automations of one change, short enough that the
// growl still feels like a response to what the user just did.
const COLLAPSE_MS = 1000

const THROTTLE_MS = 5000

let appliedIds : ID[] = []

const flushApplied = _.debounce(() => {

    const ids = _.uniq(appliedIds)
    appliedIds = []

    if (!ids.length) return

    // one automation — keep the growl that links to it
    if (ids.length === 1) {
        gd.growl.automationApplied(ids[0])
        return
    }

    // several: there is no one automation to link to, so say how many
    gd.growl.success('{0} automations applied'.f(ids.length))

}, COLLAPSE_MS)

export function growlAutomationApplied(automationId?: ID) {
    if (automationId) appliedIds.push(automationId)

    flushApplied()
}

// Leading edge: the first message over the limit is the informative one, the
// rest of the burst says nothing new.
export const growlAutomationLimitReached = _.throttle(() => {
    gd.growl.warning("Automation cascade limit reached. No further automations will be run.")
}, THROTTLE_MS, {trailing: false})
